var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"labar"},_vm._l((_vm.tabbar),function(item,i){return _c('span',{key:i,on:{"click":function($event){return _vm.laberRoute(i)}}},[_vm._v(_vm._s(item)+"\n      "),(i<_vm.tabbar.length-1)?_c('span',[_vm._v(" > ")]):_vm._e()])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-625fbf4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/layout/LabarsBread.vue
// module id = null
// module chunks = 